export const VoipConfigMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  TECHINICIAN: 'technician',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SCHEDULER: 'scheduler',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_DESTINATION: 'selectedDestination',
  INTERVAL: 'interval',
  PROXY_CONFIG: 'proxyConfig',
  THRESHOLD_CRITICALL: 'thresholdCritical',
  THRESHOLD_WARNING: 'thresholdWarning'
};

export const VOIP_AGENT_MODEL_CONFIG = {
  id: 'voip_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Voip',
          outputField: VoipConfigMapping.ALIAS,
          tabId: 'voip_setup'
        },
        customer: {
          enabled: true,
          value: '',
          outputField: VoipConfigMapping.CUSTOMER,
          tabId: 'voip_setup',
          outputOptional: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: VoipConfigMapping.TECHINICIAN,
          tabId: 'voip_setup',
          outputOptional: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: VoipConfigMapping.RUN_TYPE,
          tabId: 'voip_setup'
        },

        agentType: {
          enabled: true,
          value: 'default',
          outputField: VoipConfigMapping.AGENT_TYPE,
          tabId: 'voip_setup'
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: 'now', isValid: true },
          outputField: VoipConfigMapping.SCHEDULER,
          tabId: 'voip_setup'
        },
        interval: {
          enabled: true,
          value: 60,
          outputField: VoipConfigMapping.INTERVAL,
          tabId: 'voip_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: VoipConfigMapping.SELECTED_ORIGINATOR,
          tabId: 'voip_setup'
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: VoipConfigMapping.SELECTED_DESTINATION,
          tabId: 'voip_setup'
        },
        criticalThreshold: {
          enabled: true,
          value: 2,
          outputField: VoipConfigMapping.THRESHOLD_CRITICALL,
          tabId: 'voip_setup'
        },
        warningThreshold: {
          enabled: true,
          value: 3,
          outputField: VoipConfigMapping.THRESHOLD_WARNING,
          tabId: 'voip_setup'
        },
        proxyConfig: {
          enabled: true,
          value: [
            {
              key: 'voip.codec',
              value: '0'
            },
            {
              key: 'sip-proxy-originator',
              value: null
            },
            {
              key: 'sip-proxy-destination',
              value: null
            }
          ],
          outputField: VoipConfigMapping.PROXY_CONFIG,
          tabId: 'voip_setup',
          outputOptional: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    }
  }
};
